import { Helpers } from '../../helpers';
import { IGISStatus } from '../../interfaces/ig-i-s-status';
import { Pipeline } from '../pipeline';

export class GISStatusBase {
  GISStatusId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Pipelines_GISStatus?: Array<Pipeline> | null;

  constructor(item?: IGISStatus) {
    if (item) {

      this.GISStatusId = item.GISStatusId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Pipelines_GISStatus = Helpers.createClassArray(Pipeline, item.Pipelines_GISStatus);
    }
  }
}